import { render, staticRenderFns } from "./DadosTitular.vue?vue&type=template&id=e9dd3c86&"
import script from "./DadosTitular.vue?vue&type=script&lang=js&"
export * from "./DadosTitular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports